/* tslint:disable */
/* eslint-disable */
/**
 * classes-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const OrderStatus = {
    Draft: 'Draft',
    Submitted: 'Submitted',
    Fulfilled: 'Fulfilled',
    PaidConfirmed: 'Paid, Confirmed',
    Withdrawn: 'Withdrawn'
} as const;

export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];



